import React from 'react';
import "./Styles/SignIn.css";
import NavBar from '../NavBar';
import SignIn from './Components/SignInRoute/SignIn';
//import { BrowserView, MobileView, isBrowser, isMobile } from 'react-device-detect';
import Footer from '../Footer';
import BasketContextProvider from './Components/Context/BasketContext';

function SignInRoute() {
    return (
        <BasketContextProvider>
            <div className="SignInRoutePage">
                <div className="SignInRouteNavBar">      
                    <NavBar/>
                </div>
                <div className="SignInRoute">
                    <SignIn/>
                </div>
                <div className="SignInRouteFooter">      
                    <Footer/>
                </div>
            </div>
        </BasketContextProvider>
    );
}

export default SignInRoute;